export interface ILabelValue {
  _id?: string;
  labelName: string;
  labelColor: string;
  order?: number;
}
export interface IDropdownOptions {
  _id?: string;
  value: string;
  isDefault: boolean;
  order?: number;
}
export interface CustomFieldItem {
  _id: string;
  createdAt?: string;
  updatedAt?: string;
  associatedTicketTypes: string[];
  fieldName: string;
  fieldToolTip: CustomFieldType;
  dataType: CustomFieldType;
  isRequired: boolean;
  permission: string;
  extraParameters: {
    fieldValue: string | string[];
    tooltip: string;
  };
  labels: ILabelValue[];
  dropDownOptions: IDropdownOptions[];
}
export type ITileProps = {
  icon?: React.ReactNode; // optional — some field types don't provide an explicit icon
  title: string;
  isLink: boolean;
  link?: CustomSubMenu;
  order: number;
};
export enum CustomSubMenu {
  FIELD_TYPE = "fieldType",
  TICKET_TYPES = "ticketTypes",
  EXTRA_PARAMETER = "extraParameter",
  PERMISSION = "permission",
  MANDATORY = "mandatory",
  DROPDOWN = "Dropdown",
  LABEL = "Label",
}
export enum CustomFieldType {
  TEXT = "Text input",
  LONG_TEXT = "Long Text input",
  DROPDOWN = "Dropdown",
  DATE = "Date",
  NUMBER = "Number",
  TICKET_SINGLE_SELECT = "Ticket Single Selection",
  TEAM_MEMBER_SINGLE_SELECT = "Team Member Single Selection",
  RELEASE_SINGLE_SELECT = "Release Single Selection",
  TICKET_MULTI_SELECT = "Ticket Multi Selection",
  TEAM_MEMBER_MULTI_SELECT = "Team Member Multi Selection",
  RELEASE_MULTI_SELECT = "Release Multi Selection",
  WORK_ITEM_ID = "Work Item ID",
  TEAM_MEMBER_ID = "Team Member ID",
  RELEASE_ID = "Release ID",
  LABEL = "Label",
  URL = "URL",
  ENTITY_SINGLE_SELECTION = "Entity single select",
  ENTITY_MULTI_SELECTION = "Entity multi select",
}
export enum UpdateCustomFieldEnum {
  FIELD_NAME = "fieldName",
  FIELD_TOOL_TIP = "fieldToolTip",
  DATA_TYPE = "dataType",
  IS_REQUIRED = "isRequired",
  EXTRA_PARAMETERS = "extraParameters",
  LABELS = "labels",
  DROP_DOWN_OPTIONS = "dropDownOptions",
  TICKET_TYPE = "ticketType",
}
export type drawerType =
  | "newCustomFiled"
  | "editCustomFields"
  | "editWorkItemCustomFields";

export interface ISideDrawerOpener {
  action: boolean;
  type: drawerType | null;
}
export interface CustomFieldsState {
  loading: boolean;
  fieldLoading: boolean;
  buttonLoading: boolean;
  list: CustomFieldItem[];
  formData: CustomFieldItem;
  selectedItemId: string;
  showArchiveModal: boolean;
  sideDrawerOpen: ISideDrawerOpener;
  selectedItem: {
    id: string;
    name: string;
  } | null;
  duplicateModal: boolean;
  sideListDrawerOpen: boolean;
  duplicateId: string;
}
